"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateItemDropDown = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var CreatableItems_1 = require("./CreatableItems");
var CreateItemDropDown = function (props) {
    var itemOptions = (0, CreatableItems_1.getCreatableItems)(props);
    return (React.createElement(sok_ui_1.Dropdown2, null,
        React.createElement(sok_ui_1.Button, { size: 'large', icon: React.createElement(sok_ui_1.Icon, { className: 'fa-plus-circle' }), iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-chevron-down' }), className: 'text-left', color: 'dark-gray', text: props.text }),
        React.createElement(sok_ui_1.Dropdown2Menu, null, itemOptions)));
};
exports.CreateItemDropDown = CreateItemDropDown;
